/**
 * Color Design Tokens
 *
 * ⭐ MODIFY COLORS HERE
 * Change these values to update the entire app's color scheme
 */

export const colors = {
  // Brand Colors
  brand: {
    primary: '#6366f1',      // Electric blue - CHANGE ME
    primaryHover: '#4f46e5',
    accent: '#ff6b35',       // Evolved orange - CHANGE ME
  },

  // Light Theme (renamed from dark to keep component compatibility)
  dark: {
    bg: {
      primary: '#ffffff',    // Main background - CHANGE ME
      secondary: '#f9fafb',  // Cards (slight gray)
      tertiary: '#f3f4f6',   // Elevated surfaces
      hover: '#e5e7eb',      // Hover state
    },
    text: {
      primary: '#111827',    // Almost black
      secondary: '#6b7280',  // Gray
      tertiary: '#9ca3af',   // Light gray
      disabled: '#d1d5db',   // Very light gray
    },
    border: {
      subtle: '#f3f4f6',     // Very subtle
      default: '#e5e7eb',    // Default border
      accent: '#d1d5db',     // Accent border
    },
  },

  // Semantic Colors
  success: '#10b981',
  warning: '#f59e0b',
  error: '#ef4444',
  info: '#3b82f6',
} as const;

// Export as CSS variables for Tailwind
export const cssVariables = {
  '--brand-primary': colors.brand.primary,
  '--brand-primary-hover': colors.brand.primaryHover,
  '--brand-accent': colors.brand.accent,
  '--dark-bg-primary': colors.dark.bg.primary,
  '--dark-bg-secondary': colors.dark.bg.secondary,
  '--dark-bg-tertiary': colors.dark.bg.tertiary,
  '--dark-bg-hover': colors.dark.bg.hover,
  '--dark-text-primary': colors.dark.text.primary,
  '--dark-text-secondary': colors.dark.text.secondary,
  '--dark-text-tertiary': colors.dark.text.tertiary,
  '--dark-text-disabled': colors.dark.text.disabled,
  '--dark-border-subtle': colors.dark.border.subtle,
  '--dark-border-default': colors.dark.border.default,
  '--dark-border-accent': colors.dark.border.accent,
} as const;
